var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaqIconFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3820_34721)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.9999 9.07671C27.0101 10.9549 26.3279 12.5957 25.0078 13.9617C23.6504 15.3661 22.058 16.4923 20.5018 17.6548C19.586 18.34 18.9411 19.1825 18.5447 20.2386C18.4804 20.4105 18.4205 20.5835 18.3516 20.752C17.8209 22.0501 16.888 22.6178 15.4888 22.4798C13.857 22.3181 13.2392 21.4304 13.0156 20.2759C12.7412 18.8602 13.1195 17.5394 14.1009 16.4211C14.8496 15.5674 15.7294 14.8663 16.5967 14.1471C17.4956 13.4008 18.4567 12.7246 19.2539 11.8618C20.3042 10.7265 20.7221 9.40576 20.3008 7.88713C20.0298 6.90901 19.4098 6.19775 18.4623 5.81216C17.3556 5.36211 16.215 5.1891 15.0348 5.50233C13.8446 5.81781 12.9264 6.47479 12.3697 7.59878C12.032 8.27951 11.7169 8.97607 11.3284 9.62626C10.6091 10.8305 9.43911 11.2976 8.07264 10.9855C6.5492 10.6406 5.75982 9.36279 6.06473 7.69377C6.50742 5.27504 7.92019 3.55287 9.95859 2.2717C11.578 1.25513 13.333 0.662603 15.2347 0.538218C18.0332 0.355032 20.7096 0.815258 23.1546 2.24682C25.7351 3.75754 26.9525 6.0745 26.9988 9.07784L26.9999 9.07671Z",
    fill: "#9960C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6184 25.6823C18.7491 26.1584 19.5794 26.9275 19.8788 28.1378C20.2176 29.5053 19.8449 30.7011 18.7762 31.6228C17.6941 32.557 16.4481 32.7287 15.1061 32.2156C14.1279 31.8418 13.4874 31.1513 13.1451 30.1756C12.6786 28.1939 13.3484 26.6198 14.9909 25.8328C15.846 25.423 16.7237 25.4151 17.6184 25.6812V25.6823Z",
    fill: "#9960C9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3820_34721"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqIconFill);
export default __webpack_public_path__ + "static/media/faq-icon-fill.29672b9d779e194037a98f3b0ec8789a.svg";
export { ForwardRef as ReactComponent };